/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

var lastScrollPos = 0;

if (typeof $ === "undefined") {
    var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function (e) {
    scrollFixHeader(e);

    $(document).on('change', '#filterSelect', function(e){
        window.location.href = $(this).val();
    });

    var siteModal = getCookie('site-modal');

    if (siteModal) {
        $('.site-modal').addClass('is-hidden');
    }

    $(document).on('click', '#modalClose', function(e){
        var today = new Date();
        var expire = new Date();

        $(this).parents('.site-modal').addClass('modal-hide');
        expire.setTime(today.getTime() + 3600000*24*14);

        setCookie('site-modal', true, 14);
    });
});

$(window).scroll(function(e){
    scrollFixHeader(e);
});

function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function scrollFixHeader(event) {
    var siteHead = $('.site-header').outerHeight();
    var eyebrowHead = $('.site-header__eyebrow').outerHeight();

    var scrollPos = $(document).scrollTop();

    if (scrollPos < lastScrollPos) {
        if (scrollPos == 0) {
            $('.site-header').removeClass('is-fixed');
            $('.site-header.is-scrolling--up').removeClass('is-scrolling--up');

            $('.site-header').css({
                top: ''
            });

            $('.site-main').css({
                marginTop: ''
            });

        } else {
            $('.site-header').css({
                top: '0'
            });

            if ($('body').hasClass('admin-bar')) {

                if ($(window).width() <= 782 ) {
                    $('.site-header').css({
                        top: '46px'
                    }); 
                } else {
                    $('.site-header').css({
                        top: '32px'
                    });
                }
            }

            $('.site-header').addClass('is-scrolling--up');
        }
    } else {
        $('.site-header.is-scrolling--up').removeClass('is-scrolling--up');

        if (scrollPos >= eyebrowHead) {
            $('.site-header').addClass('is-fixed');

            $('.site-main').css({
                marginTop: siteHead
            });

            $('.site-header').css({
                top: ''
            });
        }
    }

    lastScrollPos = scrollPos;
}

// END jQuery Ready
function detectScrollbarWidth() {
    /* Detect scrollbar width to properly center full- and wide-width elements */
    let root = document.documentElement;
    var outside = document.createElement("div");
    var inside = document.createElement("div");
    
    outside.style.width = inside.style.width = "100%";
    outside.style.overflow = "scroll";
    document.body.appendChild(outside).appendChild(inside);
    
    var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;
    
    outside.parentNode.removeChild(outside);
    root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
    var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

    headings.forEach(function (head, index) {
        let str = head.textContent;
        let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
        let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

        firstSection = firstSection.trim();

        let newStr = firstSection + "\u00a0" + lastSection;

        head.innerHTML = newStr;
    });
}
